<template>
  <b-card class="mb-5 journal-style">
    <b-row class="mb-2">
      <b-col md="6">
        <h3>{{ $route.name }}</h3>

        <!-- breadcrumb -->
        <b-breadcrumb>
          <b-breadcrumb-item
            ><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
        <!-- end breadcrumb -->
      </b-col>

      <b-col md="6">
        <b-button variant="primary" class="float-right btn-custom mt-3" :to="'journal/create'"
          ><font-awesome-icon icon="plus"
        /></b-button>
      </b-col>
    </b-row>
    <div class="border-bottom"></div>

    <!-- search box filter -->

    <!-- end search  -->

    <!-- table paginate -->
   
    <paginated-table
      ref="dataTable"
      :can-edit="true"
      :can-delete="true"
      :can-approve="false"
      :can-reject="false"
      :can-show="true"
      :can-edit-modal="false"
      :can-paid="false"
      :data-url="apiUrl.journal"
      :data-key="dataKey"
      :data-columns="columns"
    ></paginated-table>
    <!-- end table -->
  </b-card>
</template>

<script>
import PaginatedTable from '../../../components/PaginatedTable.vue';
export default {
  name: 'report-index',

  components: { PaginatedTable },

  data() {
    return {
      isLoading: false,
      buttonPrev: false,
      buttonNext: true,
      // rows: 0,
      currentPage: 1,
      pageSize: '-',
      page: 1,
      perPage: 25,
      index: 0,
      dataKey: 'journal',
      columns: [
        {
          key: 'journalNumberTransaction',
          label: 'No Transaction',
        },
        {
          key: 'journalDate',
          label: 'Date',
        },
        {
          key: 'code',
          label: 'Acc Code',
        },
        {
          key: 'journalName',
          label: 'Account Name',
        },
        {
          key: 'journalTransactionNote',
          label: 'Description',
          class: 'position-relative'
        },
        {
          key: 'journalTransactionDebit',
          label: 'Debit',
        },
        {
          key: 'journalTransactionCredit',
          label: 'Credit',
        },
        {
          key: 'actionJournal',
          label: '',
        },
      ],
      apiUrl: {
        journal: window.AppConfig.apiUrl + 'journal',
      },
      model: {
        journals: [],
        paginate: 1,
      },
      canShowRoutePath: {
        type: String,
        required: false,
        default: '',
      },
    };
  },

  watch: {
  //
  },

  mounted() {
    // this.getJournalData();
  },

  methods: {

    /** get data journal from Server.
    Notes: 
        i don't use this function anymore, i don't want to remove it.
        other than that there is no code to trigger it,  so no problem for that

        hehehehhehhe(*ketawa geblekk :v)
    */
    getJournalData(pages) {
      this.isLoading = true;
      if (pages === undefined) {
        this.$http
          .get(this.apiUrl.journal + '?limit=' + this.perPage + '&page=1')
          .then((response) => {
            this.model.journals = response.data._embedded.journal.map((p) => ({
              no: p.journalNumberTransaction,
              date: p.journalDate,
              uuid: p.uuid,
              type: p.journalReferenceType,
              toUuid: p.journalReferenceUuid,
              transaction: p.journalTransaction.map((transaction) => ({
                debit: transaction.journalTransactionDebit,
                credit: transaction.journalTransactionCredit,
                note: transaction.journalTransactionNote,
                account: transaction.journalAccount,
              })),
            }));
            this.isLoading = false;
            this.rows = response.data.total_items;
          });
      } else {
        this.$http
          .get(this.apiUrl.journal + '?limit=' + this.perPage + '&page=' + pages)
          .then((response) => {
            this.model.journals = response.data._embedded.journal.map((p) => ({
              no: p.journalNumberTransaction,
              date: p.journalDate,
              uuid: p.uuid,
              type: p.journalReferenceType,
              toUuid: p.journalReferenceUuid,
              transaction: p.journalTransaction.map((transaction) => ({
                debit: transaction.journalTransactionDebit,
                credit: transaction.journalTransactionCredit,
                note: transaction.journalTransactionNote,
                account: transaction.journalAccount,
              })),
            }));
            this.rows = response.data.total_items;
            this.pageSize = response.data.page_count;
            this.page = response.data.page;
            if (this.model.paginate === response.data.page_count) {
              this.buttonNext = false;
              this.buttonPrev = true;
            } else if (this.model.paginate === 1) {
              this.buttonPrev = false;
              this.buttonNext = true;
            } else {
              this.buttonPrev = true;
              this.buttonNext = true;
            }
            this.isLoading = false;
          });
      }
    },

    doFilter() {
      //
    },

    clearFilter() {
      //
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('DD MMM YYYY HH:mm');
      } else {
        return '-';
      }
    },

    /** colores status  */
    getStatusColor(val) {
      switch (val) {
        case 'Requested':
          return 'warning';
          // eslint-disable-next-line no-unreachable
          break;

        case 'Resolved':
          return 'success';
          // eslint-disable-next-line no-unreachable
          break;
      }
    },
  },
};
</script>

<style scoped>
.journal-style {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 15px !important;
}

.money {
  font-family: 'Courier New', Courier, monospace;
}
.spinner-position {
  justify-content: center;
}

.debug {
  border: 1px dashed #ecee65;
}
</style>
